// src/main.tsx

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { runSecurityChecks } from './lib/utils/env';
import { initPostHog } from './lib/posthog';
import { initSentry } from './lib/sentry';
import { startSessionTimer, trackSessionDuration } from './lib/services/analytics/posthogService';
import { hasAnalyticsConsent, loadGA4 } from './lib/cookieConsent';

// Run security checks on startup
const securityCheck = runSecurityChecks();

if (!securityCheck.isValid) {
  console.error('❌ Security validation failed. Check console for details.');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Defer heavy analytics/error tracking initialization after first paint.
// Sentry (error tracking) always loads — it's essential for reliability.
// Analytics (PostHog, GA4) only load if the user has accepted cookie consent.
// If consent hasn't been given yet, analytics init is deferred to the
// CookieConsentBanner's accept handler.
requestIdleCallback(() => {
  initSentry();
  if (hasAnalyticsConsent()) {
    loadGA4();
    initPostHog();
    startSessionTimer();
  }
}, { timeout: 3000 });

// Track session duration when user leaves
window.addEventListener('beforeunload', () => {
  trackSessionDuration();
});

// Service worker registration is handled by vite-plugin-pwa via UpdateNotification.tsx
